import * as React from "react";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { RootState } from "../../state";
import { CompanyValue, CategorizedCompanyValueFeature, EntitiesMap } from "../entities";
import { EntitiesProvider, generateClientId } from "../../lib/entities";
import { loadCompanyValueFeaturesWorker } from "../actions";
import { categorizedFeaturesSelector } from "../selectors";
import CompanyValuesSelector from "./CompanyValuesSelector";

interface OwnProps {
  companyValues: CompanyValue[];
  onSubmit(companyValues: CompanyValue[]): void;
  onCancel(): void;
}

interface MappedProps {
  loadingFeatures: boolean;
  featuresLoaded: boolean;
  features: CategorizedCompanyValueFeature[];
  entities: EntitiesMap;
}

interface MappedActions {
  loadCompanyValueFeaturesWorker: typeof loadCompanyValueFeaturesWorker;
}

type Props = OwnProps & MappedProps & MappedActions;

interface State {
  selectedFeatures: string[];
}

class CompanyValuesSelectorContainer extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      selectedFeatures: props.companyValues
        .filter(v => v.rank >= 0)
        .sort((a, b) => a.rank - b.rank)
        .map(v => v.feature),
    };
  }

  public componentDidMount() {
    const { loadingFeatures, featuresLoaded, loadCompanyValueFeaturesWorker } = this.props;
    if (!featuresLoaded && !loadingFeatures) {
      loadCompanyValueFeaturesWorker();
    }
  }

  public onChange = (selectedFeatures: string[]) => {
    this.setState({ selectedFeatures });
  };

  public onSubmit = () => {
    const { companyValues, entities } = this.props;
    const { selectedFeatures } = this.state;
    let newValues: CompanyValue[] = selectedFeatures.map((feature, i) => {
      const found = companyValues.find(v => v.feature === feature);
      if (found) {
        return {
          ...found,
          rank: i + 1,
        };
      }
      const valueFeature = entities.company_value_features[feature]!;
      return {
        id: generateClientId(), // TODO(KentoMoriwaki): Use temporary client id
        feature,
        description: "",
        rank: i + 1,
        // Properties below will be ignored on save
        feature_cd: valueFeature.feature_cd,
        feature_color: valueFeature.feature_color,
        feature_title: valueFeature.feature_title,
        feature_title_with_break: valueFeature.feature_title_with_break,
      };
    });
    newValues = newValues.concat(
      companyValues.filter(v => !newValues.find(nv => nv.feature === v.feature)).map(v => ({ ...v, rank: -1 }))
    );
    this.props.onSubmit!(newValues);
  };

  public onCancel = () => {
    this.props.onCancel();
  };

  public render() {
    const { features, entities } = this.props;
    const { selectedFeatures } = this.state;
    return (
      <EntitiesProvider entities={entities} namespace={"company_values"}>
        <CompanyValuesSelector
          features={features}
          selectedFeatures={selectedFeatures}
          onChange={this.onChange}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
        />
      </EntitiesProvider>
    );
  }
}

function mapStateToProps(state: RootState): MappedProps {
  return {
    loadingFeatures: state.company_values.features.isLoading,
    featuresLoaded: state.company_values.features.isLoaded,
    features: categorizedFeaturesSelector(state),
    entities: state.company_values.entities,
  };
}

function mapDispatchToProps(dispatch: Dispatch<RootState>): MappedActions {
  return bindActionCreators(
    {
      loadCompanyValueFeaturesWorker,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyValuesSelectorContainer);



// WEBPACK FOOTER //
// ./frontend/src/company_values/components/CompanyValuesSelectorContainer.tsx